import { NextPage } from 'next';
import { GetStaticProps } from 'next';
import Authors from '@/components/screens/authors/Authors';
import { AUTHORS_FOR_PAGE, API_URL, REVALIDATE_TIME } from '@/helpers/variables';
import { IAuthorsPage } from '@/interfaces/authorsPage.interface';
import { IWidgetsSideBar } from '@/interfaces/widgets.interface';

interface IAuthorsPages extends IWidgetsSideBar {
  authors: IAuthorsPage;
}

const AuthorsPages: NextPage<IAuthorsPages> = ({ authors, todayWidget, popularBooksWidget }) => {
  return <Authors authors={authors} todayWidget={todayWidget} popularBooksWidget={popularBooksWidget} />;
};

export const getStaticProps: GetStaticProps = async () => {
  const authorsRes = await fetch(`${API_URL}satellite/authors?page=1&page_size=${AUTHORS_FOR_PAGE}`);
  const authors = await authorsRes.json();

  const [todayWidgetRes, popularBooksWidgetRes] = await Promise.all([fetch(`${API_URL}main/today/`), fetch(`${API_URL}main-page/popular_books`)]);
  const [todayWidget, popularBooksWidget] = await Promise.all([todayWidgetRes.json(), popularBooksWidgetRes.json()]);

  return { props: { authors, todayWidget, popularBooksWidget }, revalidate: REVALIDATE_TIME };
};

export default AuthorsPages;
